<template>
  <ak-form-decorator
      :id="id"
      :title="title"
      :helpText="helpText"
      :tooltip="tooltip"
      :error="error"
      :hasError="hasError"
      :required="required"
      :value="value"
      :hidden="hidden"
      :errorLocales="errorLocales"
  >
    <div class="ak-form__control-wrapper">
      <div class="ak-form__color-swatch" :style="{background: currentValue}"></div>

      <input
          type="text"
          v-model="currentValue"
          :placeholder="placeholder"
          :readonly="readOnly"
          class="ak-form__control ak-form__control--color"
          :class="{
                'ak-form__control--has-value': currentValue,
            }"
          @blur="blur"
          v-on="$currentListeners"
          @click.stop="showPicker"
      >
    </div>

    <transition name="slide-down">
      <SketchPicker
          v-if="pickerVisible"
          v-model="currentColor"
          v-on-click-outside:noChild="hidePicker"
          :preset-colors="presetColors"
          class="ak-form__color-picker"
      />
    </transition>
    <slot name="popover"></slot>
  </ak-form-decorator>
</template>


<script>

import FormElementMixin from '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/components/form/mixins/FormElementMixin';
import { Sketch } from 'vue-color'
export default {
  name: 'cloud-color-picker',
  mixins: [FormElementMixin],
  components: {
    SketchPicker: Sketch
  },
  data() {
    return {
      pickerVisible: false,
      removeFromListener:  ['input','updateState','blur'],
    }
  },
  props: {
    colorMode: {
      type: String,
      default: 'hex'
    },
    presetColors: {
      type: 'array',
      default: []
    }
  },
  computed: {
    /**
     * Disable alpha
     * @return {*}
     */
    disableAlpha() {
      const alphaColorModes = [
        'hex8',
        'rgba',
        'hsla',
      ];

      return ! alphaColorModes.includes(this.colorMode);
    },
    currentColor: {
      get(){
        if(! this.currentValue) {
          return '#000000';
        }

        if(this.colorMode === 'hex') {
          return this.currentValue;
        }

        if(this.colorMode === 'hex8') {
          return this.currentValue;
        }

        if(this.colorMode === 'rgb') {
          let value = this.currentValue.trim().slice(
              this.currentValue.indexOf("(") + 1,
              this.currentValue.indexOf(")")
          ).split(",");

          return {r: parseInt(value[0]), g: parseInt(value[1]), b: parseInt(value[2])};
        }

        if(this.colorMode === 'rgba') {
          let value = this.currentValue.trim().slice(
              this.currentValue.indexOf("(") + 1,
              this.currentValue.indexOf(")")
          ).split(",");

          return {r: parseInt(value[0]), g: parseInt(value[1]), b: parseInt(value[2]), a: parseInt(value[3])};
        }

        if(this.colorMode === 'hsl') {
          let value = this.currentValue.trim().slice(
              this.currentValue.indexOf("(") + 1,
              this.currentValue.indexOf(")")
          ).split(",");
          console.log(value[1].replace('%', ''));
          return {h: parseFloat(value[0]), s: parseFloat(value[1].replace('%', '') / 100), l: parseFloat(value[2].replace('%', '') / 100)};
        }

        if(this.colorMode === 'hsla') {
          let value = this.currentValue.trim().slice(
              this.currentValue.indexOf("(") + 1,
              this.currentValue.indexOf(")")
          ).split(",");

          return {h: parseInt(value[0]), s: parseFloat(value[1].replace('%', '') / 100), l: parseFloat(value[2].replace('%', '') / 100), a: parseFloat(value[3])};
        }
      },
      set(e) {
        if(this.colorMode === 'hex') {
          this.currentValue = e.hex;
        }
        if(this.colorMode === 'hex8') {
          this.currentValue = e.hex8;
        }

        if(this.colorMode === 'rgb') {
          this.currentValue = `rgb(${e.rgba.r},${e.rgba.g},${e.rgba.b})` ;
        }

        if(this.colorMode === 'rgba') {
          this.currentValue = `rgba(${e.rgba.r},${e.rgba.g},${e.rgba.b},${e.rgba.a})` ;
        }

        if(this.colorMode === 'hsl') {
          this.currentValue = `hsl(${Math.ceil(e.hsl.h)},${Math.ceil(e.hsl.s * 100)}%,${Math.ceil(e.hsl.l * 100)}%)` ;
        }

        if(this.colorMode === 'hsla') {
          this.currentValue = `hsla(${Math.ceil(e.hsl.h)},${Math.ceil(e.hsl.s * 100)}%,${Math.ceil(e.hsl.l * 100)}%,${e.hsl.a})` ;
        }

        this.$emit('blur');
      }
    }
  },
  watch: {
    currentValue() {
      if(this.currentValue === '') {
        this.pickerVisible = false;
      }
    }
  },
  methods: {
    showPicker() {
      this.pickerVisible = true;
    },
    hidePicker() {
      this.pickerVisible = false;
    },
    blur() {
      if(! this.pickerVisible) {
        this.$emit('blur');
      }
    }
  }
}
</script>